import * as React from "react";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import { patientsSortOptions } from "@/utils/constants";

import { IPatientsPropsSmall } from "@/shared/interfaces/patientPage";

import "./PatientsHeader.scss";

export default function PatientsHeaderSelector({
    sortOption,
    handleChangeSortOpton,
}: IPatientsPropsSmall) {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <React.Fragment>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    width: "44px",
                    height: "44px",
                }}
            >
                <Tooltip title='Сортування'>
                    <IconButton
                        onClick={handleClick}
                        size='small'
                        sx={{
                            width: "44px",
                            height: "44px",
                            backgroundColor: "#E7F0F8",
                            borderRadius: "6px",
                            border: "1px solid #B6D0E8",
                            transition: "all 0.3s linear",
                            "&:hover": {
                                backgroundColor: "#DCE8F4",
                            },
                        }}
                        aria-controls={open ? "account-menu" : undefined}
                        aria-haspopup='true'
                        aria-expanded={open ? "true" : undefined}
                    >
                        <img src='/patients/sort.svg' alt='' />
                    </IconButton>
                </Tooltip>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id='account-menu'
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                slotProps={{
                    paper: {
                        elevation: 0,
                        sx: {
                            width: "196px",
                            overflow: "visible",
                            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                            mt: "8px",
                            ml: "40px",
                        },
                    },
                    list: {
                        sx: {
                            width: "196px",
                            padding: 0,
                            overflow: "auto",
                        },
                    },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
            >
                <ul className='avatar_nav_list'>
                    {patientsSortOptions.map(item => (
                        <li
                            className='nav_li'
                            id='patients_sort_options'
                            onClick={() => handleChangeSortOpton(item.id)}
                            key={item.id}
                        >
                            {item.title}
                            {sortOption === item.id ? (
                                <img
                                    id={item.id}
                                    className='avatar_nav_arrow'
                                    src='/patients/check.svg'
                                    alt='logo arrow right'
                                />
                            ) : null}
                        </li>
                    ))}
                </ul>
            </Menu>
        </React.Fragment>
    );
}
